import Vue from 'vue'
import VueRouter from 'vue-router'

// import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Usuarios from '../views/Usuarios/Usuarios.vue'
import Proyecto from '../views/Proyecto/Proyecto.vue'
import ModificarProyecto from '../views/Proyecto/ModificarProyecto.vue'
import TareasTaller from '../views/Proyecto/TareasTaller/Tareas.vue';
import Almacen from '../views/Almacen/Almacen.vue'
import Requisicion from '../views/Requisicion/Requisicion.vue'
import CrearRequisicion from '../views/Requisicion/CrearRequisicion.vue'
import Pedidos from '../views/Pedidos/Pedidos.vue';
import Despiece from '../views/Despiece/Despiece.vue';
import NuevoPedido from '../views/Pedidos/NuevoPedido.vue';
import CrearDespiece from '../views/Despiece/CrearDespiece.vue'
import Maquinado from '../views/Maquinado/Maquinado.vue';
import NuevoMaquinado from '../views/Maquinado/NuevoMaquinado.vue';
import EditarMaquinado from '../views/Maquinado/EditarMaquinado.vue';
import OrdenesDeCompra from '../views/Ordenes/OrdenesDeCompra.vue';
import SalidaProcesos from '../views/SalidaProceso/SalidaProcesos.vue';
import CrearSalidaProceso from '../views/SalidaProceso/CrearSalidaProceso.vue';
import EditarSalidaProceso from '../views/SalidaProceso/EditarSalidaProceso.vue';
import Reportes from '../views/Reportes/Reportes.vue';
import Checkin from '../views/Checkin/Checkin.vue';
import TareasProyectos from '../views/Tareas/TareasProyectos.vue';

import NuevaOrdenCompra from '../views/Ordenes/NuevaOrdenCompra.vue';
Vue.use(VueRouter)

const routes = [

  { path: '/', beforeEnter: (to, from, next) => {
    if ( localStorage.getItem("usuario") && localStorage.getItem("usuario").length > 0 ) {
      next('/dashboard')
    }else{
      next('/login')
    }
  }},

  { path: '/acercade', name: 'Acerca', component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')},
  { path: '/login', name: 'Login', component: Login,},
  { path: '/dashboard', name: 'Dashboard', component: Dashboard, beforeEnter:checarSesion},

  { path: '/usuarios', name: 'Usuarios', component: Usuarios, beforeEnter:checarSesion},
  { path: '/proyecto', name: 'Proyecto', component: Proyecto, beforeEnter:checarSesion, props:true},
  { path: '/modificarProyecto/:id?', name: 'ModificarProyecto', component: ModificarProyecto, beforeEnter:checarSesion},
  { path: '/TareasTaller/:id?',    name: 'TareasTaller',    component: TareasTaller,    beforeEnter:checarSesion},

  { path: '/almacen',         name: 'Almacen',         component: Almacen,         beforeEnter:checarSesion},
  { path: '/requisicion',     name: 'Requisicion',     component: Requisicion,     beforeEnter:checarSesion},
  { path: '/crearRequisicion',name: 'CrearRequisicion',component: CrearRequisicion,beforeEnter:checarSesion},
  { path: '/pedidos',         name: 'Pedidos',         component: Pedidos,         beforeEnter:checarSesion},
  { path: '/despiece',        name: 'Despiece',        component: Despiece,        beforeEnter:checarSesion},
  { path: '/crearDespiece',   name: 'CrearDespiece',   component: CrearDespiece,   beforeEnter:checarSesion},
  { path: '/nuevoPedido',     name:'NuevoPedido',      component: NuevoPedido,     beforeEnter:checarSesion},
  { path: '/maquinado',       name:'Maquinado',        component: Maquinado,       beforeEnter:checarSesion},
  { path: '/nuevoMaquinado',  name:'NuevoMaquinado',   component: NuevoMaquinado,  beforeEnter:checarSesion},
  { path: '/editarMaquinado/:id?', name:'EditarMaquinado',   component: EditarMaquinado,beforeEnter:checarSesion},
  { path: '/OrdenesDeCompra', name:'OrdenesDeCompra',  component: OrdenesDeCompra, beforeEnter:checarSesion},
  { path: '/nuevaOrdenCompra',name:'NuevaOrdenCompra', component: NuevaOrdenCompra, beforeEnter:checarSesion},
  { path: '/salidaProcesos',  name:'SalidaProcesos',   component: SalidaProcesos, beforeEnter:checarSesion},
  { path: '/crearSalidaProceso',name:'CrearSalidaProceso',component: CrearSalidaProceso, beforeEnter:checarSesion},
  { path: '/editarSalidaProceso/:id?',name:'EditarSalidaProceso',component: EditarSalidaProceso, beforeEnter:checarSesion},
  { path: '/reportes',name:'Reportes',component: Reportes, beforeEnter:checarSesion},
  { path: '/checkin',name:'Checkin',component: Checkin, beforeEnter:checarSesion},
{ path: '/tareasProyectos',name:'TareasProyectos',component: TareasProyectos, beforeEnter:checarSesion},
// beforeEnter: (to, from, next) => {
//   if(from.name =="Proyecto" &&  from.params){
//     next({replace:true});
//   }else{
//     next('/proyecto');
//   }
// }

  // Cualquier pagina que no detecte, redireccionar a inicio 
  // ( ¿agregar pagina not found? )
  { path: "*", redirect: "/" },
]

function checarSesion(to,from,next) {
  // Checar si hay sesion iniciada
  if( localStorage.getItem("usuario") && localStorage.getItem("usuario").length > 0){
    next();
  }else
  {
    next("/login")
  }
}

const router = new VueRouter({
  mode:"hash",
  base: process.env.BASE_URL,
  routes
})

export default router
